/**
 * scrolling result
 */
export var EScrollResult;
(function (EScrollResult) {
    /**
     * nothing has changed
     */
    EScrollResult[EScrollResult["NONE"] = 0] = "NONE";
    /**
     * all rows needed to be recreated
     */
    EScrollResult[EScrollResult["ALL"] = 1] = "ALL";
    /**
     * unknown
     */
    EScrollResult[EScrollResult["SOME"] = 2] = "SOME";
    /**
     * some rows are added at the bottom
     */
    EScrollResult[EScrollResult["SOME_BOTTOM"] = 3] = "SOME_BOTTOM";
    /**
     * some rows are added at the top
     */
    EScrollResult[EScrollResult["SOME_TOP"] = 4] = "SOME_TOP";
})(EScrollResult || (EScrollResult = {}));
//# sourceMappingURL=IMixin.js.map